import { Toaster as SonnerToaster, toast } from 'sonner'
import { useTheme } from '@/stores/ThemeProvider'

/**
 * Toast —— 基于 `sonner`（AGENTS.md 9）。
 *
 * 只承担一件事：把**操作结果**告诉用户（收藏成功、复制成功、提交失败）。
 * 页面级的加载与错误状态不走 Toast —— 一闪而过的提示条替代不了
 * 「这一页出错了，点这里重试」，那是 StateBlocks 的职责。
 *
 * `theme` 必须显式跟随站点主题：sonner 默认按 `prefers-color-scheme` 判断，
 * 而本站的主题是用户可手动切换的（AGENTS.md 4.2），两者会不一致。
 */
export function Toaster() {
  const { resolved } = useTheme()
  return (
    <SonnerToaster
      theme={resolved}
      position="bottom-right"
      // 用站点 token 覆盖 sonner 自带配色，否则深浅切换时它会格格不入。
      toastOptions={{
        classNames: {
          toast:
            'rounded-card border border-border bg-surface text-foreground shadow-overlay text-sm',
          description: 'text-muted-foreground',
          actionButton: 'bg-primary text-primary-foreground',
          cancelButton: 'bg-surface-muted text-muted-foreground',
          error: 'border-danger/40',
          success: 'border-primary/40',
        },
      }}
      // 移动端顶部更容易被拇指区遮挡，桌面右下角是设计稿的空白区。
      offset={16}
      duration={4000}
      closeButton
    />
  )
}

/**
 * 站点统一的提示入口。
 *
 * 直接导出 sonner 的 `toast` 而不是再包一层：包一层只会挡住它的 `promise`、
 * `action` 等能力。这里只补一条约定 —— `toMessage()` 对「主动取消」返回空串，
 * 空串不该弹提示，所以调用方用 `notifyError` 而不是裸 `toast.error`。
 */
export { toast }

export function notifyError(message: string): void {
  if (!message) return
  toast.error(message)
}

export function notifySuccess(message: string): void {
  if (!message) return
  toast.success(message)
}
